<script>
import debounce from 'lodash/debounce';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  props: {
    // eslint-disable-next-line
    value: {
      required: true,
    },
    initialValue: {
      default: null,
      type: Object,
    },
    placeholder: {
      default: 'Type to search',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    state: {
      default: false,
      type: Boolean,
    },
    model: {
      required: true,
      type: Function,
    },
    orderBy: {
      default: '-name',
      type: String,
    },
    whereField: {
      default: 'name',
      type: String,
    },
    label: {
      default: 'name',
      type: String,
    },
  },
  data() {
    return {
      entities: [],
      isLoading: false,
      selectedEntity: this.initialValue,
      focused: false,
      minChars: 2,
    };
  },
  watch: {
    selectedEntity(val) {
      const id = val ? val.id : null;
      this.$emit('input', id);
      this.$emit('change', id);
      this.$emit('entity-change', val);
    },
    initialValue() {
      this.selectedEntity = this.initialValue;
    },
  },
  methods: {
    asyncEntities: debounce(function(query) {
      if (query.length >= this.minChars) {
        this.isLoading = true;
        this.model
          .select(['id', 'name'])
          .where(this.whereField, encodeURIComponent(query))
          .orderBy(this.orderBy)
          .page(1)
          .limit(30)
          .get()
          .then((response) => {
            this.entities = response.data;
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    }, 300),
  },
};
</script>

<template>
  <div class="multiselect-container kks-multiselect-container" :class="{ 'is-invalid': state, focused: focused }">
    <Multiselect
      ref="multiselect"
      v-model="selectedEntity"
      :label="label"
      track-by="id"
      :placeholder="placeholder"
      open-direction="bottom"
      :options="entities"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :options-limit="20"
      :max-height="600"
      :disabled="disabled"
      :show-no-results="true"
      @open="focused = true"
      @close="focused = false"
      @search-change="asyncEntities"
    >
      <div slot="noResult" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
      <div slot="noOptions" class="text-center">
        {{ $t('messages.empty_list') }}
        <br />
        {{ $t('messages.multiselect_enter') }}
      </div>
    </Multiselect>
  </div>
</template>